import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './theme/tokens.css';

const host = document.getElementById('root');
if (!host) {
  throw new Error('index.html has no #root element');
}

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
